// Narrows every board column to the chosen service type; without a type the board is kept as the API sent it.
export const filterBoardByServiceType = (board, serviceType) => {
  if (!serviceType) return board

  return Object.keys(board).reduce((filtered, status) => {
    filtered[status] = (board[status] || []).filter((item) => item.type === serviceType)
    return filtered
  }, {})
}

// Types from the real estate contract plus the ones already on the board, so an appointment of a
// service no longer in the contract (or a service provider's board, which has no contract) can still be filtered.
export const boardServiceTypeOptions = (contractTypes, board, selectedType) => {
  const values = new Set((contractTypes || []).map((type) => type.value))

  Object.values(board || {}).forEach((items) =>
    (items || []).forEach((item) => item.type && values.add(item.type))
  )

  if (selectedType) values.add(selectedType)

  return [...values]
}
